import React from "react";
import { NavLink } from "react-router-dom";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";

const NAV_LINKS = [
    { label: "Home", path: "/" },
    { label: "Projects", path: "/projects" },
    { label: "Experience", path: "/experience" },
    { label: "Blog", path: "/blog" },
    { label: "Contact", path: "/contact" },
];

const SOCIALS = [
    { icon: FaLinkedin, href: "https://www.linkedin.com/in/raviraj-kumar-019956225", label: "LinkedIn" },
    { icon: FaGithub, href: "https://www.github.com/ravirajkumartiwari", label: "GitHub" },
    { icon: FaSquareXTwitter, href: "https://twitter.com/RaviRaaZ_Tiwari", label: "X (Twitter)" },
    { icon: HiOutlineMail, href: "mailto:ravirajk545@gmail.com", label: "Email" },
];

function Footer() {
    return (
        <footer className="bg-surface-low">
            <div
                aria-hidden="true"
                className="h-px bg-outline-variant/15"
            />
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="flex flex-col md:flex-row justify-between gap-10">
                    {/* Brand */}
                    <div className="flex flex-col gap-3 max-w-xs">
                        <span className="font-signature text-[2rem] text-primary leading-none select-none">
                            Raviraj
                        </span>
                        <p className="text-sm text-on-surface-variant leading-relaxed">
                            Cloud &amp; Infrastructure Engineer specializing in Azure
                            monitoring, observability, and cost-efficient system design.
                        </p>
                    </div>

                    {/* Nav */}
                    <nav aria-label="Footer navigation">
                        <p className="section-label mb-4">Navigation</p>
                        <ul className="flex flex-col gap-2">
                            {NAV_LINKS.map(({ label, path }) => (
                                <li key={path}>
                                    <NavLink
                                        to={path}
                                        end={path === "/"}
                                        className={({ isActive }) =>
                                            `text-sm transition-colors ${
                                                isActive
                                                    ? "text-primary font-medium"
                                                    : "text-on-surface-variant hover:text-on-surface"
                                            }`
                                        }
                                    >
                                        {label}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Connect */}
                    <div>
                        <p className="section-label mb-4">Connect</p>
                        <div className="flex items-center gap-4">
                            {SOCIALS.map(({ icon: Icon, href, label }) => (
                                <a
                                    key={label}
                                    href={href}
                                    target={href.startsWith("mailto") ? undefined : "_blank"}
                                    rel="noreferrer"
                                    aria-label={label}
                                    className="text-on-surface-variant hover:text-primary transition-colors"
                                >
                                    <Icon size={20} />
                                </a>
                            ))}
                        </div>
                        <a
                            href="/resume.pdf"
                            download
                            className="btn-secondary mt-6 text-sm inline-flex"
                        >
                            Download Resume
                        </a>
                    </div>
                </div>

                {/* Bottom bar */}
                <div
                    aria-hidden="true"
                    className="h-px bg-outline-variant/15 mt-10 mb-6"
                />
                <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                    <p className="text-xs text-on-surface-variant">
                        © {new Date().getFullYear()} Raviraj Kumar Tiwari. All rights reserved.
                    </p>
                    <p className="text-xs text-on-surface-variant">
                        Cloud &amp; Infrastructure Engineer · LTIMindtree
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
